/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store";

interface IJamaState {
  lastSynchedWithJama: string | null
}

const initialState: IJamaState = {
  lastSynchedWithJama: null
} as IJamaState

const jamaSlice = createSlice({
  name: 'lastSynchedWithJama',
  initialState,
  reducers: {
    synchedWithJama: (state, action: PayloadAction<string>) => void (state.lastSynchedWithJama = action.payload),
  },
})

const selectJamaTime = (state: RootState) => state.jamaTime.lastSynchedWithJama

const {actions, reducer} = jamaSlice
export const {synchedWithJama} = actions
export {
  selectJamaTime,
}
export default reducer
